import React, { useState } from 'react';
import { Platform, TouchableOpacity, View, StyleSheet } from 'react-native';
import { CardContainer, FileIconWrap, InfoWrap, ActionsWrap, ActionBtn } from './index.style';
import PropTypes from 'prop-types';
import { MaterialCommunityIcons, MaterialIcons, Feather } from '@expo/vector-icons';
import getPlatformType from '../../helpers/helpers';
const layoutType = getPlatformType();
import Text from '../text/TextComponent';
import PopUp from '../popUp/PopupView';

/* ── Helper: derive file extension & pick icon ── */
const FILE_ICONS = {
  pdf:   { icon: 'file-pdf-box',       color: '#EF4444' },
  doc:   { icon: 'file-word-box',      color: '#2563EB' },
  docx:  { icon: 'file-word-box',      color: '#2563EB' },
  xls:   { icon: 'file-excel-box',     color: '#10B981' },
  xlsx:  { icon: 'file-excel-box',     color: '#10B981' },
  png:   { icon: 'file-image',         color: '#F59E0B' },
  jpg:   { icon: 'file-image',         color: '#F59E0B' },
  jpeg:  { icon: 'file-image',         color: '#F59E0B' },
  gif:   { icon: 'file-image',         color: '#F59E0B' },
  svg:   { icon: 'file-image',         color: '#F59E0B' },
  csv:   { icon: 'file-delimited',     color: '#10B981' },
  txt:   { icon: 'file-document',      color: '#6B7280' },
  zip:   { icon: 'folder-zip',         color: '#8B5CF6' },
  rar:   { icon: 'folder-zip',         color: '#8B5CF6' },
};

const getFileInfo = (title = '', url = '') => {
  const source = url || title;
  const ext = source.split('.').pop()?.toLowerCase()?.split('?')[0] || '';
  return FILE_ICONS[ext] || { icon: 'file-document-outline', color: '#6C2BD9' };
};

const truncateFilename = (name = '', maxLen = 32) => {
  if (name.length <= maxLen) return name;
  const ext = name.includes('.') ? '.' + name.split('.').pop() : '';
  const base = name.slice(0, maxLen - ext.length - 3);
  return base + '...' + ext;
};

const DocumentView = (props) => {
  const { leftIcon, title, description, status, statusButton, url, onDelete, directDelete } = props;
  const [isVisible, setIsVisible] = useState(false);
  const [viewHover, setViewHover] = useState(false);
  const [deleteHover, setDeleteHover] = useState(false);

  const fileInfo = getFileInfo(title, url);

  const _openURL = () => {
    if (Platform.OS === 'web') {
      window.open(url);
    }
  };

  return (
    <View style={{ marginVertical: 5 }}>
      <CardContainer>
        {/* File type icon */}
        <FileIconWrap style={{ backgroundColor: fileInfo.color + '14' }}>
          <MaterialCommunityIcons name={fileInfo.icon} size={22} color={fileInfo.color} />
        </FileIconWrap>

        {/* File name & extension tag */}
        <InfoWrap>
          <Text
            fontSize={14}
            fontWeight={'600'}
            color={'#111827'}
            numberOfLines={1}
          >
            {truncateFilename(title)}
          </Text>
          {url ? (
            <Text
              fontSize={11}
              fontWeight={'400'}
              color={'#9CA3AF'}
              style={{ marginTop: 2 }}
              numberOfLines={1}
            >
              {(url.split('.').pop()?.split('?')[0] || 'file').toUpperCase()} document
            </Text>
          ) : null}
        </InfoWrap>

        {/* Action buttons */}
        <ActionsWrap>
          {/* View / Open */}
          <TouchableOpacity
            onPress={_openURL}
            activeOpacity={0.7}
            onMouseEnter={() => setViewHover(true)}
            onMouseLeave={() => setViewHover(false)}
          >
            <ActionBtn style={viewHover ? styles.actionBtnHover : styles.actionBtnDefault}>
              <Feather name="eye" size={16} color={viewHover ? '#6C2BD9' : '#6B7280'} />
            </ActionBtn>
          </TouchableOpacity>

          {/* Delete / Archive */}
          <TouchableOpacity
            onPress={() => {
              if (directDelete) {
                props.onDelete(true);
              } else {
                setIsVisible(true);
              }
            }}
            activeOpacity={0.7}
            onMouseEnter={() => setDeleteHover(true)}
            onMouseLeave={() => setDeleteHover(false)}
          >
            <ActionBtn style={deleteHover ? styles.actionBtnDeleteHover : styles.actionBtnDefault}>
              <Feather name="trash-2" size={16} color={deleteHover ? '#EF4444' : '#6B7280'} />
            </ActionBtn>
          </TouchableOpacity>
        </ActionsWrap>
      </CardContainer>

      <PopUp
        modalVisible={isVisible}
        titleText={'Archive Document?'}
        titleColor={'#6D08C0'}
        subTitleText={`What do you want to do with this document?\nArchive the document or Keep it in your "My Docs" section`}
        subTitleColor={'black'}
        actionButtons={[
          {
            text: 'Archive',
            width: 100,
            onPress: () => {
              onDelete();
              setIsVisible(false);
            },
          },
          {
            text: 'My Docs',
            width: 100,
            onPress: () => {
              onDelete(true);
              setIsVisible(false);
            },
          },
        ]}
        closePopup={() => setIsVisible(false)}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  actionBtnDefault: {
    backgroundColor: '#F9FAFB',
  },
  actionBtnHover: {
    backgroundColor: '#F0E8FF',
  },
  actionBtnDeleteHover: {
    backgroundColor: '#FEF2F2',
  },
});

DocumentView.propTypes = {
  leftIcon: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.number,
  statusButton: PropTypes.bool,
  onPress: PropTypes.func,
};

DocumentView.defaultProps = {
  leftIcon: 'map-marker',
  onPress: () => {},
  title: 'Document',
  status: 0,
  description: '',
};

export default DocumentView;
